import { render, staticRenderFns } from "./CardPairedProfile.vue?vue&type=template&id=554d979a&scoped=true"
import script from "./CardPairedProfile.vue?vue&type=script&lang=js"
export * from "./CardPairedProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554d979a",
  null
  
)

export default component.exports